import React from "react";
import { Link } from "react-router-dom";
import type { SupportTicket } from "../../types/supportTicket";
import TicketStatusBadge from "./TicketStatusBadge";
import TicketPriorityBadge from "./TicketPriorityBadge";
import { formatDateTime } from "../../utils/dateFormat";

interface Props {
  tickets: SupportTicket[];
  detailBasePath: string;
  showSubscriber?: boolean;
}

const TicketTable: React.FC<Props> = ({
  tickets,
  detailBasePath,
  showSubscriber = false,
}) => {
  return (
    <div className="ticket-table-wrapper">
      <table className="ticket-table">
        <thead>
          <tr>
            <th>ID</th>
            <th>Subject</th>
            {showSubscriber && <th>Subscriber</th>}
            <th>Department</th>
            <th>Priority</th>
            <th>Created On</th>
            <th>Status</th>
            <th>Manage</th>
          </tr>
        </thead>
        <tbody>
          {tickets.length > 0 ? (
            tickets.map((ticket) => (
              <tr key={ticket.id}>
                <td>{ticket.ticketNo}</td>
                <td>
                  <div className="ticket-subject-cell">
                    <strong>{ticket.subject}</strong>
                    {ticket.service && <small>{ticket.service}</small>}
                  </div>
                </td>
                {showSubscriber && (
                  <td>
                    <div className="ticket-subject-cell">
                      <strong>{ticket.subscriberName || "-"}</strong>
                      <small>{ticket.subscriberEmail || "-"}</small>
                    </div>
                  </td>
                )}
                <td>{ticket.department}</td>
                <td>
                  <TicketPriorityBadge priority={ticket.priority} />
                </td>
                <td>{formatDateTime(ticket.createdAt)}</td>
                <td>
                  <TicketStatusBadge status={ticket.status} />
                </td>
                <td>
                  <Link
                    to={`${detailBasePath}/${ticket.id}`}
                    className="ticket-view-btn"
                  >
                    <i className="fa fa-search" /> View
                  </Link>
                </td>
              </tr>
            ))
          ) : (
            <tr>
              <td
                colSpan={showSubscriber ? 8 : 7}
                className="ticket-empty-cell"
              >
                No tickets found.
              </td>
            </tr>
          )}
        </tbody>
      </table>
    </div>
  );
};

export default TicketTable;
